import moment, { DurationInputArg1, DurationInputArg2 } from "moment";
import { useEffect, useState } from "react";
import { appConfig } from "../../configs";
import { filterConstants, TTransactionPeriodSelect } from "../../constants";
import { useQueryString, useQueryStringFilter } from "../../hooks";
import { IKeyValuePair, IKeyValuePairT } from "../../interfaces-and-types";
import { ISelectProps } from "../Select/Select";
import { View } from "./View";

const PERIOD_OPTIONS = [
  "custom",
  "last 7 days",
  "last 1 month",
  "last 6 months",
];

export interface IPeriodFilterViewProps extends IPeriodFilterProps {
  options: IKeyValuePairT<TTransactionPeriodSelect>[];
  onChange: (value: any) => void;
}

export interface IPeriodFilterProps {
  // queryStringPrefix: string;
  appendQueryStringPrefixWithTableId?: (queryKey: string) => string;
  // activePeriodValue: string;
  // setPeriodValue: (periodToSet: string) => void;
}

export const PeriodFilter = (props: IPeriodFilterProps) => {
  const { appendQueryStringPrefixWithTableId = (queryKey) => queryKey } = props;

  const query = useQueryString();
  const startDate = query.get(
    appendQueryStringPrefixWithTableId(filterConstants.startDateKey)
  );
  const endDate = query.get(
    appendQueryStringPrefixWithTableId(filterConstants.endDateKey)
  );

  const [filterPeriodValue, setFilterPeriodValue] =
    useState<TTransactionPeriodSelect>(null);

  const { seturlQueryStringFilter } = useQueryStringFilter([
    [
      appendQueryStringPrefixWithTableId(filterConstants.startDateKey),
      moment(startDate).format(appConfig.dateFormat1),
    ],
    [
      appendQueryStringPrefixWithTableId(filterConstants.endDateKey),
      moment(endDate).format(appConfig.dateFormat2),
    ],
  ]);

  const onChange = (val: TTransactionPeriodSelect) => {
    let duration: DurationInputArg1 = 30;
    let momentPeriodType: DurationInputArg2 = "days";

    switch (val) {
      case "Today":
        duration = 1;
        momentPeriodType = "days";
        break;
      case "7d":
        duration = 7;
        momentPeriodType = "days";
        break;
      case "1m":
        duration = 1;
        momentPeriodType = "months";
        break;
      case "6m":
        duration = 6;
        momentPeriodType = "months";
        break;
      // case "1y":
      //   duration = 1;
      //   momentPeriodType = "years";
      //   break;
      default:
        break;
    }

    const newStartDate = moment()
      .subtract(duration, momentPeriodType)
      .format(appConfig.dateFormat1);

    const newEndDate = moment().format(appConfig.dateFormat1);

    // console.log("newStartDate", newStartDate);
    // console.log("newEndDate", newEndDate);

    if (val === null) {
      seturlQueryStringFilter(
        {
          [appendQueryStringPrefixWithTableId(filterConstants.startDateKey)]:
            "",
          [appendQueryStringPrefixWithTableId(filterConstants.endDateKey)]: "",
        },
        true
      );
    } else
      seturlQueryStringFilter(
        {
          [appendQueryStringPrefixWithTableId(filterConstants.startDateKey)]:
            newStartDate,
          [appendQueryStringPrefixWithTableId(filterConstants.endDateKey)]:
            newEndDate,
        },
        true
      );

    // console.log("PeriodFilter newStartDate: ", newStartDate);
    // console.log("PeriodFilter newEndDate: ", newEndDate);
  };

  // set current page on url when page changed in table
  useEffect(() => {
    // console.log("filterPeriodValue: ", filterPeriodValue);
    onChange(filterPeriodValue);
  }, [filterPeriodValue]);

  return (
    <View
      options={filterConstants.transactionPeriods}
      onChange={setFilterPeriodValue}
      {...props}
    />
  );
};
